/* eslint-disable no-nested-ternary */
import { Button, Chip, Container, Divider, Icon, Paper, Typography } from '@mui/material';
import getAPIUrl from '../../../config';
import { postApiWithAuth } from '../../../utils/apiCalls';
import DataTable from '../../common/DataTable';
import Filter from '../../common/Filter';
import Header from '../../common/Header/Header';
import Loading from '../../common/Loading';
import NoResultsFound from '../../common/NoResultsFound';
import { useToast } from '../../common/ToasterContext';
import ContentFilterModal from '../ContentFilterModal';
import styles from './styles';
import { ContentProps } from './types';

const ContentList = ({
    user,
    tableData,
    columns,
    loadMore,
    hasMore,
    setOpenProfileDetails,
    openProfileDetails,
    onFiltersApplyClick,
    onFiltersClearClick,
    selectedStatus,
    onStatusChange,
    onAuthorChange,
    onCategoryChange,
    onFilterChipDelete,
    searchChange,
    authors,
    categories,
    loader,
    sortData,
    setSuggestedResource,
    suggestedResource,
    onSaveSuggestedResource,
    setReload,
    reload,
}: ContentProps) => {
    const toast = useToast();

    const onChipDelete = (type: 'status' | 'category' | 'author', name?: string) => {
        if (onFilterChipDelete) {
            onFilterChipDelete(type, name);
        }
    };

    const checkedAuthors = authors.filter((a) => a.checked);
    const checkedCategories = categories.filter((a) => a.checked);

    return (
        <Container sx={styles.container} maxWidth={false}>
            <Header
                profileImg={user.profileImg}
                name={user.name}
                titleComponent={
                    <Typography component="div" sx={styles.header}>
                        <Typography id="content_management_title" component="div" sx={styles.title}>
                            Content Management
                        </Typography>
                    </Typography>
                }
                setOpenProfileDetails={setOpenProfileDetails}
                openProfileDetails={openProfileDetails}
            />
            <Paper elevation={1} sx={styles.table}>
                <Typography component="div" sx={styles.content}>
                    <Typography component="div">
                        <Filter
                            id="content-search"
                            onApplyFiltersClick={onFiltersApplyClick}
                            onFiltersClearClick={onFiltersClearClick}
                            placeholder="Search resource..."
                            searchChange={searchChange}
                            modalContent={
                                <ContentFilterModal
                                    authors={authors}
                                    categories={categories}
                                    selectedStatus={selectedStatus}
                                    onAuthorChange={onAuthorChange}
                                    onCategoryChange={onCategoryChange}
                                    onStatusChange={onStatusChange}
                                />
                            }
                        />
                    </Typography>
                    <Typography component="div" sx={styles.selectedFilters}>
                        {selectedStatus && (
                            <Chip
                                key="statusChip"
                                id="statusChip"
                                sx={styles.chip}
                                color="primary"
                                onDelete={() => onChipDelete('status')}
                                label={selectedStatus === 'active' ? 'Active' : 'Inactive'}
                                variant="outlined"
                                deleteIcon={
                                    <Icon sx={styles.chipDelete}>
                                        <img alt="" src="./images/chip-delete.svg" />
                                    </Icon>
                                }
                            />
                        )}{' '}
                        {checkedAuthors.length !== 0 &&
                            checkedAuthors.map((a) => (
                                <>
                                    <Chip
                                        key={a.name}
                                        id="authorChip"
                                        sx={styles.chip}
                                        color="primary"
                                        onDelete={() => onChipDelete('author', a.name)}
                                        label={a.name}
                                        variant="outlined"
                                        deleteIcon={
                                            <Icon sx={styles.chipDelete}>
                                                <img alt="" src="./images/chip-delete.svg" />
                                            </Icon>
                                        }
                                    />{' '}
                                </>
                            ))}
                        {checkedCategories.length !== 0 &&
                            checkedCategories.map((c) => (
                                <>
                                    <Chip
                                        key={c.name}
                                        id="categoryChip"
                                        sx={styles.chip}
                                        color="primary"
                                        onDelete={() => onChipDelete('category', c.name)}
                                        label={c.name}
                                        variant="outlined"
                                        deleteIcon={
                                            <Icon sx={styles.chipDelete}>
                                                <img alt="" src="./images/chip-delete.svg" />
                                            </Icon>
                                        }
                                    />{' '}
                                </>
                            ))}
                    </Typography>
                    <Button
                        sx={styles.suncButton}
                        id="sync_articles"
                        color="primary"
                        variant="contained"
                        disableRipple
                        onClick={async () => {
                            try {
                                const res = await postApiWithAuth(`${getAPIUrl()}/admins/sync-october-data`, {});
                                if (toast) {
                                    toast.onToggleSnackbar();
                                    toast.onMessage(res.data.data);
                                    toast.onSuccess();
                                }
                                if (setReload) {
                                    setReload(!reload);
                                }
                            } catch (error: any) {
                                if (toast) {
                                    toast.onToggleSnackbar();
                                    toast.onMessage(error.response.data.errors);
                                    toast.onError();
                                }
                            }
                        }}
                    >
                        Sync Articles from October
                    </Button>
                    {suggestedResource ? (
                        <Button
                            sx={styles.suggestedButton}
                            id="save_suggested_resource"
                            variant="outlined"
                            disableRipple
                            onClick={onSaveSuggestedResource}
                        >
                            Save Suggested Resources
                        </Button>
                    ) : (
                        <Button
                            sx={styles.suggestedButton}
                            id="manage_suggested_resource"
                            color="primary"
                            variant="contained"
                            disableRipple
                            onClick={() => setSuggestedResource(true)}
                        >
                            Manage Suggested Resources
                        </Button>
                    )}
                </Typography>
                <Divider sx={styles.divider} />
                {loader ? (
                    <Loading />
                ) : searchChange && tableData.length > 0 ? (
                    <>
                        {suggestedResource ? (
                            <Typography id="suggested_resources_title" component="div" sx={styles.suggestedResource}>
                                Suggested Resources
                            </Typography>
                        ) : null}
                        <DataTable
                            columns={columns}
                            data={tableData}
                            loadMore={loadMore}
                            hasMore={hasMore}
                            sortData={sortData}
                        />
                    </>
                ) : (
                    <NoResultsFound />
                )}
            </Paper>
        </Container>
    );
};

export default ContentList;
